var _defs, _rect, _circle, _circle2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkPassportPageHeroLuminousVerificationBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1600,
    height: 1000,
    viewBox: "0 0 1600 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Work Passport hero luminous verification background") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero-grid-blue"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFF",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero-grid-green"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30D6A1",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30D6A1",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 1000,
    fill: "#020716"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1260,
    cy: 250,
    r: 500,
    fill: "url(#hero-grid-blue)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 920,
    r: 350,
    fill: "url(#hero-grid-green)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#74BDFF",
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1200,
    cy: 400,
    r: 250
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1200,
    cy: 400,
    r: 340
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1200,
    cy: 400,
    r: 430
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 880L1440 40M180 140h380M1050 830h420"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#30D6A1",
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 170,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 620,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1450,
    cy: 520,
    r: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPassportPageHeroLuminousVerificationBackground);
export default __webpack_public_path__ + "static/media/work-passport-page-hero-luminous-verification-background.277221056b1209dd6a6ffb008ea1689a.svg";
export { ForwardRef as ReactComponent };